module.exports = __webpack_public_path__ + "static/media/01 ON INTERNET ALÁMBRICO 30.037c9042.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAl/01 ON INTERNET ALÁMBRICO 30.pdf
// module id = 856
// module chunks = 0